import { render, staticRenderFns } from "./AuthLoading.vue?vue&type=template&id=0ac3cd79&"
import script from "./AuthLoading.vue?vue&type=script&lang=ts&"
export * from "./AuthLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports